module.exports = __webpack_public_path__ + "img/index_icon2.40910974.png";